import { createStore } from "vuex";
import { ulsname } from "../project/Source/localstate";
import {
  LoadUser,
  SaveStatePlugin,
  GetSession,
  RemoveSession,
} from "../project/Source/localstate";

export default createStore({
  plugins: [SaveStatePlugin], 
  state: {
    user: null,
    jwt: "",
    carepJwt: "",
  },
  mutations: {
    LOGOUT_USER(state) {
      state.user = null;
      state.jwt = "";
      localStorage.removeItem(ulsname); 
    },
    SET_JWT_TOKEN(state, token) {
      state.jwt = token;
    },
    SET_CAREP_JWT(state, token) {
      state.carepJwt = token;
    },
    initialiseStore(state) {
      let user = LoadUser();
      if (user && user.jwt && GetSession()) {
        state.user = user;
      } else {
        state.user = null;
        state.jwt = "";
      }
    },
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {
    logout({ commit }) {
      commit("LOGOUT_USER");
      RemoveSession();
    },
  },
  getters: {
    jwt: (state) => (state.user ? state.user.jwt : "NA"),
    carepJwt: (state) => state.carepJwt,
  },
});
